// raindrops (raindrops.js)
jQuery(function($) {
  var $target = $('#js-raindrops');
  if ($target.length) {
    // // console.log('yuka');
    // // 対象ノード
    // // オブザーバーインスタンス準備
    // var observer = new MutationObserver(function (mutations) {
    //   console.log('属性変わったよ');
    // });
    //
    // // オブザーバーの監視対象の設定
    // var config = {
    //   attributes: true, // 属性変化の監視
    //   attributeOldValue: true, // 変化前の属性値を matation.oldValue に格納する
    //   characterData: false, // テキストノードの変化を監視
    //   characterDataOldValue: false, // 変化前のテキストを matation.oldValue に格納する
    //   childList: false, // 子ノードの変化を監視
    //   subtree: false // 子孫ノードも監視対象に含める
    // };
    //
    // //対象と設定を渡す
    // observer.observe($target[0] , config);
    //
    $target.raindrops(
      {color:'#f9e3cc', rippleSpeed:0.2}
    );
  }
});
